interface EnvironmentConfig {
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
  app: {
    name: string;
    version: string;
    environment: 'development' | 'production' | 'staging';
  };
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isProduction = import.meta.env.PROD;
  const isDevelopment = import.meta.env.DEV;

  return {
    firebase: {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyA8gc7FYxCI2c6SFS1XD2emBF-jelFjsY0',
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'invertite-app.firebaseapp.com',
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'invertite-app',
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'invertite-app.firebasestorage.app',
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '81030696351',
      appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:81030696351:web:0ee5e73f8d622fbbac41aa',
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-DRZHP8PP8F',
    },
    app: {
      name: import.meta.env.VITE_APP_NAME || 'Invirtiendo',
      version: import.meta.env.VITE_APP_VERSION || '1.0.0',
      environment: isProduction ? 'production' : isDevelopment ? 'development' : 'staging',
    },
  };
};

export const environmentConfig = getEnvironmentConfig();
export type { EnvironmentConfig };
